import React from 'react';
import './SelectOption.scss';

interface SelectOptionProps {
  text: string;
  label?: string;
  description?: string;
  onSelect: () => void;
  isSelected?: boolean;
  isDisabled?: boolean;
  isSpecial?: boolean;
}

export const SelectOption: React.FC<SelectOptionProps> = (props) => {
  const { text, label, description, onSelect, isSelected, isDisabled, isSpecial } = props;

  const disabledClassNameFactory = (className: string): string => (
    isDisabled === true ? `${className} disabled` : className
  )

  const specialClassNameFactory = (className: string): string => (
    isSpecial === true ? `${className} special` : className
  )

  const selectedClassNameFactory = (className: string): string => (
    isSelected === true ? `${className} selected` : className
  )

  const descriptionClassNameFactory = (className: string): string => (
    Boolean(description) === true ? `${className} description` : className
  )

  const onClick = (): void => {
    if (!isDisabled) {
      onSelect()
    }
  }

  return (
    <div 
      className={
        descriptionClassNameFactory(
          disabledClassNameFactory(
            selectedClassNameFactory(
              specialClassNameFactory('select-option')
              )
            )
          )
      }
      onClick={onClick}
    >
      <p className={'text'}>{label || text}</p>
      {
        description
        ?
        <p className={'description'}>{description}</p>
        :
        null
      }
    </div>
  );
}